import LocationUtil, {getAppBaseHref} from '../../util/locationUtil';

export function getApiBasePath(): string {
  return LocationUtil.getOwnDomainURL() + getAppBaseHref() + 'api/0.exp';
}
